import React from 'react';

import styles from './troy.module.scss';

import Header from '.';

const TroyHeader = () => <Header {...{ styles }} />;

TroyHeader.propTypes = {};

export default TroyHeader;
